import { WorkItemLaneType } from './work-item-lane-type.enum';

export const cannedIntegrationDescriptors = [
  {
    id: 4,
    name: 'zendesk',
    icon: 'integration-zendesk',
    type: WorkItemLaneType.EmbeddedIntegration
  },
  {
    id: 7,
    name: 'salesforce',
    icon: 'integration-salesforce',
    type: WorkItemLaneType.SalesforceIntegration
  }
];
